/** <prebf-bundle>: live bundle calculator. Reads the cart, shows the tier reached and the saving. */
class PrebfBundle extends HTMLElement {
  connectedCallback() {
    this.tiers = (this.dataset.tiers || '')
      .split(',')
      .map((t) => t.split(':').map(Number))
      .filter((t) => t[0] > 0)
      .sort((a, b) => a[0] - b[0]);
    this.count = Number(this.dataset.count) || 0;
    this.base = Number(this.dataset.base) || 0;
    this.onCart = () => this.refresh();
    document.addEventListener('cart:update', this.onCart);
    this.render();
    this.refresh();
    this.bindCode();
  }

  disconnectedCallback() {
    document.removeEventListener('cart:update', this.onCart);
  }

  async refresh() {
    try {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      this.count = cart.item_count || 0;
      this.base = (cart.items || []).reduce((n, i) => n + (i.original_line_price || 0), 0);
      this.render();
    } catch (_) {}
  }

  money(cents) {
    try {
      return new Intl.NumberFormat(this.dataset.locale || undefined, { style: 'currency', currency: this.dataset.currency }).format(cents / 100);
    } catch (_) {
      return (cents / 100).toFixed(2);
    }
  }

  fill(text, map) {
    return Object.keys(map).reduce((s, k) => s.split('[' + k + ']').join(map[k]), text || '');
  }

  render() {
    const count = this.count;
    let reached = null;
    let next = null;
    for (const t of this.tiers) {
      if (count >= t[0]) reached = t;
      else if (!next) next = t;
    }

    this.querySelectorAll('.prebf__tier').forEach((el) => {
      const q = Number(el.dataset.qty);
      el.dataset.state = reached && q === reached[0] ? 'reached' : next && q === next[0] ? 'next' : '';
    });

    const left = this.querySelector('[data-left]');
    const right = this.querySelector('[data-right]');
    const hint = this.querySelector('[data-hint]');
    const first = this.tiers[0];

    if (count === 0) {
      left.textContent = this.fill(this.dataset.tEmpty, { more: first ? first[0] : '', pct: first ? first[1] : '' });
      right.textContent = '';
      hint.textContent = '';
      return;
    }

    left.textContent = this.fill(this.dataset.tBag, { count, total: this.money(this.base) });
    if (reached) {
      const saved = Math.round((this.base * reached[1]) / 100);
      right.innerHTML = this.fill(this.dataset.tSave, { saved: '<b>' + this.money(saved) + '</b>', final: this.money(this.base - saved) });
    } else {
      right.textContent = '';
    }
    hint.textContent = next
      ? this.fill(this.dataset.tMore, { more: next[0] - count, pct: next[1] })
      : this.dataset.tTop || '';
  }

  bindCode() {
    const box = document.querySelector('[data-prebf-code]');
    if (!box || box.dataset.bound) return;
    box.dataset.bound = '1';
    const btn = box.querySelector('.prebf-code__btn');
    btn.addEventListener('click', async () => {
      const code = box.dataset.prebfCode;
      try {
        await navigator.clipboard.writeText(code);
      } catch (_) {
        const r = document.createRange();
        r.selectNodeContents(box.querySelector('strong'));
        const s = getSelection();
        s.removeAllRanges();
        s.addRange(r);
      }
      btn.textContent = btn.dataset.copiedLabel;
      setTimeout(() => (btn.textContent = btn.dataset.copyLabel), 1800);
    });
  }
}

if (!customElements.get('prebf-bundle')) customElements.define('prebf-bundle', PrebfBundle);
